import styled, { css } from 'styled-components';

import { ids } from '@icarros/theme-react';

interface OpenEditActionsWrapperProps {
  isBody?: boolean;
}

interface ListItemModifierProps {
  isNormalCase?: boolean;
}

export const PriceInfoWrapper = styled.div`
  width: 100%;
`;

export const PriceAndButtonWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 1366px) {
    flex-direction: column;
  }
`;

export const OpenEditActionsWrapper = styled.div<OpenEditActionsWrapperProps>`
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  z-index: var(--overlay-z);
  padding-block-end: 24px;
  margin-top: 20px;

  > div {
    width: 100vw;
  }

  @media (min-width: 1366px) {
    > div {
      width: 50.3vw;
      margin-left: -32px;
    }
  }
  ${({ isBody }) =>
    !isBody &&
    css`
      button {
        width: 90%;
        max-width: 600px;
      }

      @media (min-width: 1366px) {
        align-items: flex-start;
        button {
          width: 90%;
          max-width: 600px;
          margin-left: 24px;
        }
      }
    `}

  ${({ isBody }) =>
    isBody &&
    css`
      top: 90vh;
      button {
        width: 100%;
      }

      @media (min-width: 1366px) {
        top: 0;
        > div {
          display: none;
        }
      }
    `}
`;

export const OpenEditWrapper = styled.div`
  margin-block-start: 32px;
`;

export const OpenEditTitleWrapper = styled.div`
  > div:nth-of-type(2) {
    margin-block-start: 8px;
  }
  > div:nth-of-type(3) {
    margin-block: 32px;
  }
  margin-bottom: 44px;
`;

export const ListItemModifier = styled.div<ListItemModifierProps>`
  ${({ isNormalCase }) =>
    !isNormalCase &&
    css`
      text-transform: lowercase;
    `}
  > div {
    width: 100%;

    > div:first-of-type {
      margin-left: 0;
    }
  }

  &:last-of-type {
    > div:last-of-type {
      display: none;
    }
  }
`;

export const EmptyContainer = styled.div`
  div:first-of-type {
    margin-top: 16px;
    margin-bottom: 4px;
  }

  div:last-of-type {
    margin-top: 16px;
  }
`;

export const ActionWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 28px;
  justify-content: flex-start;
  > button {
    width: fit-content;
    flex-direction: row-reverse;
    padding-left: 0;
  }
`;

export const ContainerNps = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80vh;
`;

export const GalleryWrapper = styled.div`
  .torque-card-upload .torque-card-upload-container__delete-icon svg,
  .torque-card-upload .torque-card-upload-container__edit-icon svg {
    fill: ${ids.color.action.primary.ids_color_action_primary_variant};
  }
  .torque-card-upload .torque-card-upload-container__description {
    background-color: ${ids.color.action.primary.ids_color_action_primary_variant};
  }
  .torque-card-upload--main .torque-card-upload__card {
    border: 1px solid ${ids.color.action.primary.ids_color_action_primary_variant};
  }

  @media (min-width: 1366px) {
    .torque-gallery-upload__container {
      gap: 16px;
    }
    .torque-card-upload {
      margin: 0 !important;
      width: 236px !important;
      height: calc((236px / 16) * 9) !important;
    }
  }

  @media (max-width: 425px) {
    .torque-gallery-upload__container {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;
    }
    .torque-card-upload {
      margin: 0 !important;
      width: 100% !important;
      height: 120px !important;
      flex: auto;
    }
  }
`;

export const ActionsButtonsWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding-top: 24px;

  @media (max-width: 425px) {
    flex-direction: column;
    gap: 12px;
    border-top: 1px solid #D6D0CC;
  }
`

export const ModalContainer= styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;

  > label {
    padding: 0;
  }
`

export const SuccessChassiModalLayout = styled.div`
  width: 312px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
`

export const SuccessChassiModalLayoutLogoFeedback = styled.div`
  padding-bottom: 24px;
`

export const SuccessChassiModalLayoutMainContent = styled.div`
  text-align: center;
  padding-bottom: 32px;
`

export const ActionButtonCustom = styled.div`
  width: 100%;
  height: auto;
  padding-top: 16px;
  > button {
    padding: 0;
    flex-direction: row-reverse;
  }
`

export const ModalInfoChassiLayout = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ModalInfoChassiContent = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 46px;
`